const ConfigurationNavMixin = {
  data() {
    return {
      navItems: [
        {path: '/configuration/authenticators/', name: 'Authenticators'},
        {path: '/configuration/alarm/', name: 'Device Alarm'},
        {path: '/configuration/webhooks/', name: 'Webhooks'},
      ],
    }
  },
}

export default ConfigurationNavMixin
